/*******************************************************************************
FADE IN FLEXBOX ELEMENT
*******************************************************************************/

export default function addjQueryPlugin() {
    $.fn.flexFadeIn = function flexFadeIn(hideClasses, speed, callback) {
        callback = callback || function emptyCallback() {};
        hideClasses = hideClasses || 'hide';
        this.css('opacity', '0').removeClass(hideClasses).animate({ opacity: 1 }, speed || '300');
        callback();
        return this;
    };
}
